export default __webpack_public_path__ + "static/media/moments.0fbecf8f.png";